/**
 * 📷 재고 실사 사진 폴더(NAS) 쓰기 점검 (v2.224.0 · 2026-10-01) — 시스템 관리 › 연동 도구
 *
 * 사진은 NAS 「4. 기술지원부\포털 재고실사 사진」에만 둔다(사용자 결정). 서비스 계정이 그 폴더에 쓸 수 있는지는
 * 운영에서만 알 수 있어, 관리자가 자리에서 한 번 눌러 **쓰기 → 되읽기 → 지우기**를 돌려 본다.
 */

import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { api, ApiCallError } from '../lib/api';

type Probe = { kind: 'nas' | 'local'; ok: boolean; message: string; path: string };

export function StockPhotoNasCard() {
  const [result, setResult] = useState<Probe | null>(null);
  const [error, setError] = useState<string | null>(null);
  const run = useMutation({
    mutationFn: () => api.post<Probe>('/admin/stock-photo-check', {}),
    onSuccess: (r) => { setResult(r); setError(null); },
    onError: (e: Error) => { setError(e instanceof ApiCallError ? e.message : '점검 실패'); setResult(null); },
  });

  return (
    <div className="bg-white rounded shadow-sm border border-slate-200 p-4">
      <h2 className="ui-section-title mb-1">📷 재고 실사 사진 폴더(NAS) 점검</h2>
      <p className="text-xs text-slate-500 mb-3">
        주간 확인·분기 실사 사진은 NAS <code className="bg-slate-100 px-1 rounded">4. 기술지원부\포털 재고실사 사진</code> 에 보관됩니다.
        서비스 계정으로 그 폴더에 작은 시험 파일을 <strong>쓰고 · 되읽고 · 지워</strong> 봅니다(폴더가 없으면 만듭니다).
      </p>
      <button type="button" onClick={() => run.mutate()} disabled={run.isPending}
        className="btn btn-primary">
        {run.isPending ? '점검 중…' : '지금 점검'}
      </button>
      {error && <div className="mt-3 text-sm text-red-700 bg-red-50 border border-red-200 rounded px-3 py-2">{error}</div>}
      {result && (
        <div className={`mt-3 text-sm rounded px-3 py-2 border ${result.ok ? 'text-emerald-800 bg-emerald-50 border-emerald-200' : 'text-red-700 bg-red-50 border-red-200'}`}>
          <div>{result.ok ? '✅' : '⚠'} {result.message}</div>
          <div className="text-xs mt-1 opacity-80 break-all">{result.kind === 'nas' ? 'NAS' : '개발 PC 임시 폴더'} · {result.path}</div>
        </div>
      )}
    </div>
  );
}
